var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-title',[_vm._v("\n    "+_vm._s(_vm.$t('fields.create_account'))+"\n  ")]),_vm._v(" "),_c('register')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }